import { Box, DialogHeader, DialogHeaderProps, Text } from '@chakra-ui/react';
import { CloseIcon } from 'assets/icons/v2';
import React, { ReactElement } from 'react';

type Props = DialogHeaderProps & {
  handleClose: () => void;
  title?: string;
  floatingCross?: boolean;
};

export const CustomModalHeader = ({
  title,
  handleClose,
  floatingCross = false,
  ...props
}: Props): ReactElement => {
  return (
    <DialogHeader {...props} p="0">
      <Box
        position="relative"
        p="25px 20px"
        borderBottom={title ? 'default' : undefined}
        borderBottomColor={title ? 'border.accent' : undefined}
        textAlign={{ base: 'start', md: 'center' }}
        width="100%"
      >
        <Text as="h2" textStyle="h3.medium">
          {title}
        </Text>

        {!floatingCross && (
          <CloseIcon
            w="20px"
            h="20px"
            onClick={handleClose}
            cursor="pointer"
            color="text.secondary"
            position="absolute"
            right="20px"
            top="50%"
            transform="translateY(-50%)"
          />
        )}
      </Box>
    </DialogHeader>
  );
};
